module.exports = __webpack_public_path__ + "media/flags/nc-d38cb96a.svg";